export default [
    { name: "12", value: "12" }, 
    { name: "12A", value: "12A"}, 
    { name: "15", value: "15" }, 
    { name: "18", value: "18" }, 
    { name: "G", value: "G" }, 
    { name: "PG", value: "PG" }, 
    { name: "RE", value: "RE" }, 
    { name: "TBC", value: "TBC"}
]